export default {
  name: "Navigation",
  menu_admin:false,
  props: {
    drawerClicked: {
      required: true,
      type: Boolean,
    },
  },

  watch: {
    drawerClicked() {
      this.drawer = !this.drawer;
    },
  },
  methods: {

  },

  data: () => ({
    drawer: false,
    menu: [],
    menu_default: [
      {
        id: 'home-0',
        funcionalidade_nome: "Página Inicial",
        icone: "mdi-home",
        rota: "/",
      },
      {
        id: 'home-1',
        funcionalidade_nome: "Controle de Acesso",
        icone: "mdi-lock",
        rota: "/controle-acesso",
      },
      {
        id: 'configuracoes-sistema',
        funcionalidade_nome: "Sistema",
        icone: "mdi-cog",
        sub: [
          {
            id: 'configuracoes-tabelas-cargas',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Cargas",
            icone: "mdi-file-import",
            rota: "/gerenciar-tabelas-cargas",
          },
          {
            id: 'configuracoes-tabelas-basicas',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Planilha",
            icone: "mdi-file-spreadsheet",
            rota: "/gerenciar-tabelas-basicas",
          }
        ]
      },
      {
        id: 'gerenciamento-tabelas',
        funcionalidade_nome: "Configurações",
        icone: "mdi-cogs",
        sub: [
          {
            id: 'acoes-1',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Ações",
            icone: "mdi-shape",
            rota: "/gerenciar-acoes",
          },
          {
            id: 'elemento-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Elementos",
            icone: "mdi-calendar",
            rota: "/gerenciar-elementos",
          },
          {
            id: 'elementos-items-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Elementos Itens",
            icone: "mdi-shape-outline",
            rota: "/gerenciar-elementos-itens",
          },
          {
            id: 'exercicios-1',
            hierarquia: 2,
            funcionalidade_nome: "Gerenciar Exercícios",
            icone: "mdi-calendar",
            rota: "/gerenciar-exercicios",
          },
          {
            id: 'fontes-1',
            hierarquia: 3,
            funcionalidade_nome: "Gerenciar Fontes",
            icone: "mdi-database",
            rota: "/gerenciar-fontes",
          },
          {
            id: 'grupo-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Grupos",
            icone: "mdi-account-group",
            rota: "/gerenciar-grupos",
          },
          {
            id: 'ipg-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar IPGs",
            icone: "mdi-cube",
            rota: "/gerenciar-ipgs",
          },
          {
            id: 'ipu-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar IPUs",
            icone: "mdi-cube-outline",
            rota: "/gerenciar-ipus",
          },
          {
            id: 'programa-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Programas",
            icone: "mdi-application",
            rota: "/gerenciar-programas",
          },
          {
            id: 'secoes-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Seções",
            icone: "mdi-view-list",
            rota: "/gerenciar-secoes",
          },
          {
            id: 'unidade-orcamentaria-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Unidades Orçamentárias",
            icone: "mdi-domain",
            rota: "/gerenciar-unidades-orcamentarias",
          },
          {
            id: 'unidade-executora-1',
            hierarquia: 4,
            funcionalidade_nome: "Gerenciar Unidades Executoras",
            icone: "mdi-office-building",
            rota: "/gerenciar-unidades-executoras",
          },
        ]
      },
      {
        id: 'elementos-primarios',
        funcionalidade_nome: "Elementos Primárias",
        icone: "mdi-cube-outline",
        sub: [
          // {
          //   id: 'importar-unidades-primarias',
          //   hierarquia: 1,
          //   funcionalidade_nome: "Importar Unidades Primárias",
          //   icone: "mdi-file-import",
          //   rota: "/importar-unidades-primarias",
          // },
          // {
          //   id: 'visualizar-unidades-primarias',
          //   hierarquia: 1,
          //   funcionalidade_nome: "Visualizar Unidades Primárias",
          //   icone: "mdi-eye",
          //   rota: "/gerenciar-unidades-primarias",
          // },
          {
            id: 'importar-elementos-primarios',
            hierarquia: 1,
            funcionalidade_nome: "Importar Elementos Primários",
            icone: "mdi-file-import",
            rota: "/importar-elementos-primarios",
          },
          {
            id: 'gerenciar-ppag',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar PPAG",
            icone: "mdi-timeline-text",
            rota: "/gerenciar-ppag",
          },
          {
            id: 'gerenciar-emendas-estaduais',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar EP. Emenda Estadual",
            icone: "mdi-file-document-outline",
            rota: "/gerenciar-emendas-estaduais",
          },
          {
            id: 'gerenciar-emendas-federais',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar EP. Emenda Federal",
            icone: "mdi-file-document-outline",
            rota: "/gerenciar-emendas-federais",
          },
          {
            id: 'gerenciar-convenios-federais',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar EP. Convênio Federal",
            icone: "mdi-file-document-outline",
            rota: "/gerenciar-convenios-federais",
          },
          {
            id: 'gerenciar-elementos-primarios-genericos',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar EP. Genérico",
            icone: "mdi-cog",
            rota: "/gerenciar-elementos-primarios-genericos",
          },
          {
            id: 'gerenciar-elementos-primarios-consolidados',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Elementos Primários",
            icone: "mdi-view-dashboard",
            rota: "/gerenciar-elementos-primarios-consolidados",
          }
        ]
      },
      {
        id: 'planos-aquisicao',
        funcionalidade_nome: "Plano de Aquisição",
        icone: "mdi-timeline-text",
        sub: [
          {
            id: 'planos-aquisicao',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Planos de Aquisição",
            icone: "mdi-timeline-text",
            rota: "/gerenciar-planos-aquisicao",
          },
          {
            id: 'planos-aquisicao-montar',
            hierarquia: 1,
            funcionalidade_nome: "Montar Plano",
            icone: "mdi-timeline-text",
            rota: "/montar-plano-aquisicao",
          }
        ]
      },
      {
        id: 'processos-compra',
        funcionalidade_nome: "Processos de Compra",
        icone: "mdi-shopping",
        sub: [
          {
            id: 'gerenciar-processos-compras',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Processos de Compra",
            icone: "mdi-shopping",
            rota: "/gerenciar-processos-compras",
          },
          {
            id: 'importar-processos-compra',
            hierarquia: 1,
            funcionalidade_nome: "Importar Processos",
            icone: "mdi-file-import",
            rota: "/importar-processos-compra",
          },
          {
            id: 'gerenciar-empenhos',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Especificações de Empenhos (SIAD)",
            icone: "mdi-file-document",
            rota: "/gerenciar-empenhos",
          },
          {
            id: 'importar-empenhos',
            hierarquia: 1,
            funcionalidade_nome: "Importar Especificações de Empenhos (SIAD)",
            icone: "mdi-file-import",
            rota: "/importar-empenhos",
          },
        ]
      },
      {
        id: 'empenhos',
        funcionalidade_nome: "Empenhos",
        icone: "mdi-file-document",
        sub: [
         
          {
            id: 'gerenciar-empenhos-siaf',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Empenhos (SIAF)",
            icone: "mdi-file-document-outline",
            rota: "/gerenciar-empenhos-siaf",
          },
          {
            id: 'importar-empenhos-siaf',
            hierarquia: 1,
            funcionalidade_nome: "Importar Empenhos (SIAF)",
            icone: "mdi-file-import-outline",
            rota: "/importar-empenhos-siaf",
          },
          {
            id: 'importar-restos-pagar',
            hierarquia: 1,
            funcionalidade_nome: "Importar Restos a Pagar (SIAF)",
            icone: "mdi-clock-alert",
            rota: "/importar-restos-pagar-siaf",
          },
          {
            id: 'importar-transacoes-empenhos',
            hierarquia: 1,
            funcionalidade_nome: "Importar Transações de Empenhos (SIAF)",
            icone: "mdi-swap-horizontal",
            rota: "/importar-transacoes-empenho-siaf",
          },
          {
            id: 'gerenciar-transacoes-empenhos',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Transações de Empenho",
            icone: "mdi-table-search",
            rota: "/gerenciar-transacoes-empenho-siaf",
          }
        ]
      },
      {
        id: 'aprovacoes',
        funcionalidade_nome: "Aprovações",
        icone: "mdi-check-circle",
        sub: [
          {
            id: 'gerenciar-aprovacoes-orcamentarias',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Aprovações",
            icone: "mdi-clipboard-list",
            rota: "/gerenciar-aprovacoes-orcamentarias",
          },
          {
            id: 'importar-aprovacoes-orcamentarias',
            hierarquia: 1,
            funcionalidade_nome: "Importar Aprovações",
            icone: "mdi-file-import",
            rota: "/importar-aprovacoes-orcamentarias",
          }
        ]
      },
      {
        id: 'descentralizacoes',
        funcionalidade_nome: "Descentralizações",
        icone: "mdi-share-variant",
        sub: [
          {
            id: 'gerenciar-descentralizacoes-orcamentarias',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Descentralizações",
            icone: "mdi-clipboard-list",
            rota: "/gerenciar-descentralizacoes-orcamentarias",
          },
          {
            id: 'importar-descentralizacoes-orcamentarias',
            hierarquia: 1,
            funcionalidade_nome: "Importar Descentralizações",
            icone: "mdi-file-import",
            rota: "/importar-descentralizacoes-orcamentarias",
          }
        ]
      },
      {
        id: 'repasses',
        funcionalidade_nome: "Repasses",
        icone: "mdi-transfer",
        sub: [
          {
            id: 'gerenciar-repasses-orcamentarios',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Repasses",
            icone: "mdi-clipboard-list",
            rota: "/gerenciar-repasses-orcamentarios",
          },
          {
            id: 'importar-repasses-orcamentarios',
            hierarquia: 1,
            funcionalidade_nome: "Importar Repasses",
            icone: "mdi-file-import",
            rota: "/importar-repasses-orcamentarios",
          }
        ]
      },
      {
        id: 'dotacao',
        funcionalidade_nome: "Dotações",
        icone: "mdi-cash",
        sub: [
          {
            id: 'gerenciar-dotacoes-orcamentarias',
            hierarquia: 1,
            funcionalidade_nome: "Gerenciar Dotações",
            icone: "mdi-clipboard-list",
            rota: "/gerenciar-dotacoes-orcamentarias",
          },
          {
            id: 'importar-dotacoes-orcamentarias',
            hierarquia: 1,
            funcionalidade_nome: "Importar Dotações",
            icone: "mdi-file-import",
            rota: "/importar-dotacoes-orcamentarias",
          }
        ]
      }
      // {
      //   id: 'logs',
      //   funcionalidade_nome: "Logs",
      //   icone: "mdi-file-document",
      //   sub: [
      //     {
      //       id: 'configuracao-logs',
      //       hierarquia: 1,
      //       funcionalidade_nome: "Configuração Logs",
      //       icone: "mdi-book",
      //       rota: "/logs/configuracao",
      //     }, {
      //       id: 'gerenciar-logs',
      //       hierarquia: 1,
      //       funcionalidade_nome: "Gerenciar Logs",
      //       icone: "mdi-book",
      //       rota: "/logs/gerenciar",
      //     }
      //   ]
      // }
    ]
  }),
};